// Junta o retorno de erros do validarPlanilha aos itens importados, casando
// pelo numero do item. Itens sem erro ficam com erro/dcRetorno indefinidos,
// que e o formato que as telas de veiculo ja esperam.
function mesclarErrosNosItens(conteudoPlanilha, erroPlanilha) {
  if (!(conteudoPlanilha instanceof Array)) {
    return [];
  }
  const erros = erroPlanilha instanceof Array ? erroPlanilha : [];
  return conteudoPlanilha.map(item => {
    const erro = erros.find(v => v.item === item.item);
    return { ...item, erro: erro && erro.erro, dcRetorno: erro && erro.dcRetorno };
  });
}

export default { mesclarErrosNosItens };



// WEBPACK FOOTER //
// ./src/helpers/planilha-itens.js